import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Router } from "./router";
import { environmentTitlePrefix } from "./lib/env-title";
import "./index.css";

// Base title lives in index.html; only the environment tag is added here.
document.title = `${environmentTitlePrefix(import.meta.env)}${document.title}`;

const root = document.getElementById("root");

if (!root) {
  throw new Error("Root element #root was not found");
}

createRoot(root).render(
  <StrictMode>
    <Router />
  </StrictMode>
);
